import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import AttorneyRightSidebarTwoGridSectionOne from '../../components/attorney-components/AttorneyRightSidebarTwoGridSectionOne';
import FooterOne from '../../common/footer/FooterOne';

const AttorneyRightSidebarTwoGridOne = () => {
    return (
        <>
        <HeaderOne />

        <BreadcrumbOne 
            title="Attorney Right Sidebar Two Grid 1"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="Attorney Right Sidebar Two Grid 1"
        />
        
        <AttorneyRightSidebarTwoGridSectionOne />
        
        <FooterOne />
        </>
    )
}
    
export default AttorneyRightSidebarTwoGridOne;